module.exports = __webpack_public_path__ + "img/expert-talks.9e91f319.png";